var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 340.53 342.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 35.86,
    y1: 73.05,
    x2: 312.17,
    y2: 274.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1dd7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d0ad6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3d18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 105.75,
    y1: 183.25,
    x2: 234.77,
    y2: 183.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 170.26,
    y1: 334.9,
    x2: 170.27,
    y2: 334.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 63.41,
    y1: 297.45,
    x2: 109.42,
    y2: 313.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1dd7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d0ad6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3d18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 144.4,
    y1: 304.19,
    x2: 99.88,
    y2: 290.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1dd7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d0ad6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3d18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 165.81,
    y1: 292.76,
    x2: 214.7,
    y2: 306.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1dd7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d0ad6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0ad6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 220.63,
    y1: 290.32,
    x2: 283.01,
    y2: 307.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1dd7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#e2ca73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a67d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d0ad6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3d18"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.36,112.56c0-3.39-2.74-6.14-6.11-6.13l-98.36,.15c-.84,0-1.53-.68-1.53-1.53V7.47c0-4.12-3.32-7.47-7.43-7.47H113.6c-4.11,0-7.43,3.35-7.43,7.47V105.26c0,.84-.69,1.53-1.52,1.53l-98.58,.15C2.71,106.95,0,109.7,0,113.07l.17,116.66c0,3.39,2.74,6.14,6.11,6.13l98.36-.15c.84,0,1.53,.68,1.53,1.53v25.7h7.8v-33.56c0-.85-.69-1.53-1.53-1.53h-6.27s-95.68,.16-95.68,.16c-1.67,0-3.05-1.36-3.05-3.05l-.17-107.11c0-1.69,1.37-3.07,3.05-3.07l95.84-.14h6.21c.87-.02,1.59-.73,1.59-1.61V11.74c0-2.44,1.96-4.41,4.38-4.41h103.82c2.43,0,4.38,1.97,4.38,4.41V112.85c0,.89,.72,1.6,1.59,1.6h6.21s95.68-.16,95.68-.16c1.67,0,3.05,1.36,3.05,3.05l.17,107.11c0,1.69-1.37,3.07-3.05,3.07l-95.84,.14-6.28,.02c-.84,0-1.52,.68-1.52,1.53v33.73h7.8v-25.9c0-.84,.69-1.53,1.52-1.53l98.58-.15c3.36,0,6.08-2.76,6.07-6.14l-.17-116.66ZM106.18,334.97c.07,4.06,3.36,7.33,7.42,7.33h113.33c4.06,0,7.35-3.27,7.42-7.33H106.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.43,124.95c-11.06-.04-21.25,4.82-28.17,13.19-6.91-8.37-17.11-13.23-28.17-13.19-20.72,.07-36.92,17.86-36.33,38.69,.93,32.87,24.95,62.49,63.15,77.65,.43,.17,.89,.26,1.35,.26s.91-.09,1.35-.26c38.2-15.16,62.22-44.78,63.15-77.65,.59-20.83-15.61-38.62-36.33-38.69Zm-85.35,38.02c-.34-15.91,12.26-30.06,28.08-30.63,10.66-.38,20.44,4.93,25.98,14.03,.66,1.1,1.85,1.77,3.13,1.77s2.46-.67,3.13-1.77c5.54-9.11,15.32-14.41,25.98-14.03,15.82,.57,28.41,14.71,28.08,30.63-.14,6.43-1.27,12.74-3.31,18.82h-44.39c-.75,0-1.42,.43-1.71,1.09l-2.22,5.1-1.81-5.84-2.33-7.57-2.33-7.57-1.05-3.44c-.23-.75-.95-1.26-1.76-1.27h-.02c-.81,0-1.53,.5-1.76,1.24l-2.22,6.83-1.79,5.47-3.6,10.93-1.81,5.46-3.05,9.15-1.07-4.21-3.74-14.96c-.19-.75-.86-1.29-1.67-1.35-.81-.06-1.56,.4-1.86,1.12l-2.31,5.69-3.67-9.42c-.25-.63-.84-1.07-1.54-1.14-.7-.07-1.38,.24-1.76,.81l-2.58,3.87h-15.69c-2.04-6.08-3.17-12.39-3.31-18.82Zm57.18,70.92c-25.79-10.57-44.41-28.12-52.58-48.57h15.4c.63,0,1.22-.31,1.56-.82l1.13-1.69,4.07,10.45c.27,.69,.95,1.15,1.72,1.15,.78,0,1.47-.44,1.74-1.12l1.93-4.75,2.36,9.45,2.62,10.35c.2,.77,.9,1.32,1.74,1.35h.06c.81,0,1.53-.5,1.76-1.23l5.05-15.17,1.81-5.47,3.6-10.93,1.78-5.47,.41-1.25,1.66,5.41,2.33,7.57,3.25,10.48c.21,.7,.88,1.21,1.64,1.26,.78,.05,1.5-.36,1.81-1.04l1.3-2.75s.02-.03,.03-.04l2.44-5.57c.03-.09,.14-.15,.24-.15h41.69c-8.17,20.44-26.79,37.99-52.58,48.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.27,334.97h0v-.14s0,.09,0,.14Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.41,324.03c-1.39,0-2.39-.21-3.01-.61-.62-.41-1.02-.95-1.18-1.62-.17-.67-.25-1.39-.25-2.16v-41.61c0-.82,.08-1.56,.25-2.24,.17-.67,.55-1.2,1.15-1.59,.6-.38,1.59-.58,2.98-.58s2.31,.19,2.9,.58c.6,.38,.98,.91,1.15,1.59,.17,.67,.25,1.42,.25,2.24v37.69c0,.29,.24,.53,.53,.53h21.34c.72,0,1.36,.06,1.94,.18,.57,.12,1.03,.46,1.36,1.01,.33,.55,.5,1.43,.5,2.63s-.17,2.08-.5,2.63c-.33,.55-.79,.91-1.36,1.08-.57,.17-1.22,.25-1.94,.25h-26.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.41,323.96c-1.29,0-2.24-.21-2.83-.61-.6-.41-.98-.95-1.15-1.62-.17-.67-.25-1.39-.25-2.16v-41.83c0-.72,.09-1.39,.29-2.02,.19-.62,.61-1.13,1.25-1.51,.65-.38,1.61-.58,2.9-.58,1.43,0,2.43,.16,2.98,.47,.55,.31,1.06,.76,1.54,1.33l22.99,32.33c.3,.42,.96,.21,.96-.31v-29.71c0-.72,.1-1.39,.29-2.02,.19-.62,.6-1.13,1.22-1.51,.62-.38,1.58-.58,2.87-.58s2.31,.2,2.9,.61c.6,.41,.98,.95,1.15,1.62,.17,.67,.25,1.42,.25,2.24v41.54c0,.77-.11,1.48-.32,2.13-.21,.65-.65,1.18-1.29,1.59-.65,.41-1.64,.61-2.98,.61-1.05,0-1.88-.1-2.47-.29-.6-.19-1.14-.6-1.61-1.23l-23.35-32.28c-.3-.42-.96-.2-.96,.31v29.16c0,.77-.08,1.48-.25,2.13-.17,.65-.56,1.18-1.18,1.59-.62,.41-1.6,.61-2.94,.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.85,323.96c-1.24,0-2.18-.19-2.8-.58-.62-.38-1.02-.91-1.18-1.59-.17-.67-.25-1.42-.25-2.24v-41.61c0-.77,.08-1.48,.25-2.13,.17-.65,.56-1.18,1.18-1.59,.62-.41,1.6-.61,2.94-.61,1,0,1.76,.06,2.26,.18,.5,.12,.9,.29,1.18,.5s.57,.49,.86,.83l17.5,24.59h-1.65l17.57-24.67c.33-.38,.67-.67,1-.87,.33-.19,.76-.34,1.29-.43,.53-.1,1.22-.14,2.08-.14,1.29,0,2.25,.2,2.87,.61,.62,.41,1.02,.95,1.18,1.62,.17,.67,.25,1.42,.25,2.24v41.61c0,.72-.08,1.42-.25,2.09-.17,.67-.56,1.2-1.18,1.59-.62,.38-1.6,.58-2.94,.58s-2.25-.21-2.87-.61c-.62-.41-1.02-.95-1.18-1.62-.17-.67-.25-1.39-.25-2.16v-29.24c0-.52-.67-.73-.96-.3l-12.09,17.57c-.14,.19-.36,.44-.64,.76-.29,.31-.67,.59-1.15,.83-.48,.24-1.12,.36-1.94,.36-.76,0-1.39-.12-1.86-.36-.48-.24-.85-.51-1.11-.79-.26-.28-.5-.56-.73-.84-.01-.02-.02-.03-.04-.05l-12-17.47c-.3-.43-.97-.22-.97,.3v29.38c0,.72-.08,1.42-.25,2.09-.17,.67-.56,1.2-1.18,1.59-.62,.38-1.6,.58-2.94,.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.02,323.96c-1.24,0-2.18-.19-2.8-.58-.62-.38-1.02-.91-1.18-1.59-.17-.67-.25-1.42-.25-2.24v-41.61c0-.77,.08-1.48,.25-2.13,.17-.65,.56-1.18,1.18-1.59,.62-.41,1.6-.61,2.94-.61,1,0,1.76,.06,2.26,.18,.5,.12,.9,.29,1.18,.5s.57,.49,.86,.83l17.5,24.59h-1.65l17.57-24.67c.33-.38,.67-.67,1-.87,.33-.19,.76-.34,1.29-.43,.53-.1,1.22-.14,2.08-.14,1.29,0,2.25,.2,2.87,.61,.62,.41,1.02,.95,1.18,1.62,.17,.67,.25,1.42,.25,2.24v41.61c0,.72-.08,1.42-.25,2.09-.17,.67-.56,1.2-1.18,1.59-.62,.38-1.6,.58-2.94,.58s-2.25-.21-2.87-.61c-.62-.41-1.02-.95-1.18-1.62-.17-.67-.25-1.39-.25-2.16v-29.24c0-.52-.67-.73-.96-.3l-12.09,17.57c-.14,.19-.36,.44-.65,.76-.29,.31-.67,.59-1.15,.83-.48,.24-1.12,.36-1.94,.36-.77,0-1.39-.12-1.87-.36-.48-.24-.85-.51-1.11-.79-.26-.28-.5-.56-.74-.84-.01-.01-.02-.03-.03-.04l-12-17.47c-.3-.43-.97-.22-.97,.3v29.38c0,.72-.08,1.42-.25,2.09-.17,.67-.56,1.2-1.18,1.59-.62,.38-1.6,.58-2.94,.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.19784b20551bd5a0c8552c89d3dacabd.svg";
export { ForwardRef as ReactComponent };